export default __webpack_public_path__ + "static/media/KeepWritting.1089a6f9.PNG";